(function installVenadaAnnouncement(global) {
  'use strict';

  if (global.VenadaAnnouncement) return;

  var ROTATE_DELAY = 5000;
  var controllers = new WeakMap();

  function createController(root, options) {
    options = options || {};
    var items = Array.from(root.querySelectorAll('[data-venada-announcement-item]'));
    var toggle = root.querySelector('[data-venada-announcement-toggle]');
    var prefersReducedMotion = Boolean(options.prefersReducedMotion);
    var setTimer = options.setTimer || global.setTimeout.bind(global);
    var clearTimer = options.clearTimer || global.clearTimeout.bind(global);
    var activeIndex = 0;
    var timerId = null;
    var pauseReasons = new Set();
    var controlPaused = false;
    var destroyed = false;

    function show(index) {
      activeIndex = index;
      items.forEach(function updateVisibility(item, itemIndex) {
        item.hidden = itemIndex !== activeIndex;
      });
    }

    function stop() {
      if (timerId === null) return;
      clearTimer(timerId);
      timerId = null;
    }

    function schedule() {
      stop();
      if (destroyed || pauseReasons.size > 0 || prefersReducedMotion || items.length < 2) return;
      timerId = setTimer(function rotate() {
        timerId = null;
        show((activeIndex + 1) % items.length);
        schedule();
      }, ROTATE_DELAY);
    }

    function pause(reason) {
      pauseReasons.add(reason || 'manual');
      stop();
    }

    function resume(reason) {
      pauseReasons.delete(reason || 'manual');
      schedule();
    }

    function onPointerEnter() {
      pause('pointer');
    }

    function onPointerLeave() {
      resume('pointer');
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', controlPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', controlPaused ? 'Resume announcements' : 'Pause announcements');
      toggle.textContent = controlPaused ? 'Resume' : 'Pause';
    }

    function onToggle() {
      controlPaused = !controlPaused;
      updateToggle();
      if (controlPaused) pause('control');
      else resume('control');
    }

    root.addEventListener('pointerenter', onPointerEnter);
    root.addEventListener('pointerleave', onPointerLeave);
    if (toggle) {
      toggle.hidden = prefersReducedMotion || items.length < 2;
      updateToggle();
      toggle.addEventListener('click', onToggle);
    }
    show(0);
    schedule();

    return {
      destroy: function destroy() {
        if (destroyed) return;
        destroyed = true;
        stop();
        pauseReasons.clear();
        root.removeEventListener('pointerenter', onPointerEnter);
        root.removeEventListener('pointerleave', onPointerLeave);
        if (toggle) {
          toggle.removeEventListener('click', onToggle);
          toggle.hidden = true;
        }
      },
      pause: pause,
      resume: resume
    };
  }

  function init(root) {
    if (!root || controllers.has(root)) return;
    var controller = createController(root, {
      prefersReducedMotion: global.matchMedia('(prefers-reduced-motion: reduce)').matches
    });
    controllers.set(root, controller);
  }

  function initWithin(scope) {
    if (scope.matches && scope.matches('[data-venada-announcement]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-venada-announcement]').forEach(init);
  }

  function destroyWithin(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-venada-announcement]')) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll('[data-venada-announcement]')));
    roots.forEach(function destroyRoot(root) {
      var controller = controllers.get(root);
      if (controller) controller.destroy();
      controllers.delete(root);
    });
  }

  function onVisibilityChange() {
    document.querySelectorAll('[data-venada-announcement]').forEach(function update(root) {
      var controller = controllers.get(root);
      if (!controller) return;
      if (document.hidden) controller.pause('visibility');
      else controller.resume('visibility');
    });
  }

  global.VenadaAnnouncement = {
    ROTATE_DELAY: ROTATE_DELAY,
    createController: createController,
    initWithin: initWithin,
    destroyWithin: destroyWithin
  };

  function installRuntime() {
    initWithin(document);
    document.addEventListener('visibilitychange', onVisibilityChange);
    document.addEventListener('shopify:section:load', function onSectionLoad(event) {
      initWithin(event.target);
    });
    document.addEventListener('shopify:section:unload', function onSectionUnload(event) {
      destroyWithin(event.target);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installRuntime, {once: true});
  else installRuntime();
})(window);
